"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formSerialize = _interopRequireDefault(require("form-serialize"));
var _animation = _interopRequireDefault(require("@spothero/utils/animation"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Form extends _react.Component {
  static defaultProps = {
    invalidElementScrollOffset: 0
  };
  constructor(props) {
    super(props);
    if (!props.id) {
      throw new Error(`The prop 'id' is required to make Form accessible for users using assistive technologies such as screen readers. Check the render method of Form.`);
    }
  }
  _onSubmit = evt => {
    evt.preventDefault();
    const {
      onSubmit
    } = this.props;
    const form = evt.currentTarget;

    // for browsers that don't run validation checks on submit
    if (form.checkValidity && !form.checkValidity()) {
      return;
    } else {
      if (onSubmit) {
        onSubmit(evt);
      }
    }
  };

  /**
   * Animates the Form component to the first invalid field.
   *
   * @public
   * @returns {void}
   */
  animateToInvalid() {
    if (this._form.checkValidity && !this._form.checkValidity()) {
      const {
        id,
        invalidElementToScroll,
        invalidElementScrollOffset
      } = this.props;

      // setTimeout to ensure elements are rendered
      setTimeout(() => {
        const errorField = _dom.default.el(`#Form-${id} .FormElement-contains-error`);
        const firstInvalid = Array.isArray(errorField) ? errorField[0] : errorField;
        const yPos = firstInvalid.offsetTop + invalidElementScrollOffset;
        const elToScroll = invalidElementToScroll || document.scrollingElement;
        _animation.default.scrollTo(elToScroll, yPos);
      }, 0);
    }
  }

  /**
   * Checks if the form is valid and ready for submission.
   *
   * @public
   * @returns {Boolean} - Whether the form is valid or not.
   */
  isValid() {
    return this._form.checkValidity ? this._form.checkValidity() : true;
  }

  /**
   * Resets user input from the form fields.
   *
   * @public
   * @returns {void}
   */
  reset() {
    this._form.reset();
  }

  /**
   * Provides the form data as an object for submission.
   *
   * @public
   * @param {Boolean} [withEmpty=false] - Whether to serialize the empty fields.
   * @returns {Object} - The form data to submit.
   */
  submit(withEmpty = false) {
    if (!this.isValid()) {
      return null;
    }
    return (0, _formSerialize.default)(this._form, {
      hash: true,
      empty: withEmpty
    });
  }

  /**
   * Getter for the form DOM element.
   *
   * @public
   * @returns {Element} - The form element.
   */
  get node() {
    return this._form;
  }
  render() {
    const {
      className,
      id,
      children
    } = this.props;
    const classes = (0, _classnames.default)('Form', className);
    return /*#__PURE__*/_react.default.createElement("form", {
      ref: node => {
        this._form = node;
      },
      className: classes,
      id: `Form-${id}`,
      onSubmit: this._onSubmit,
      action: ""
    }, children);
  }
}
exports.default = Form;